<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-new-menu"
      scrollable
      centered
      title="Menu - Adicionar Item"
      button-size="sm"
    >
    <div class="form-group row mb-4">
      <div class="col-md-12 pt-2">
        <label for="txtData"> Descrição:</label>
        <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite a descrição do novo item de menu'"
               v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state">
            </b-form-input>
          </div>
      </div>
      <div class="col-md-6 pt-3">
        <label for="txtData"> Seção:</label>
        <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o nome da Seção'"
               v-model="form.secaoNome.value"
              :size="form.secaoNome.maxlength"
              :required="form.secaoNome.required"
              :state="form.secaoNome.state"
              disabled>
            </b-form-input>
          </div>
      </div>
      <div class="col-md-6 pt-3">
        <label for="txtData"> Menu:</label>
        <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o nome do Menu'"
               v-model="form.menuNome.value"
              :size="form.menuNome.maxlength"
              :required="form.menuNome.required"
              :state="form.menuNome.state"
              disabled>
            </b-form-input>
          </div>
      </div>
      <div class="col-md-6 pt-3">
        <label for="txtData"> Proprietário:</label>
        <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o nome do proprietário'"
               v-model="form.dono.value"
              :size="form.dono.maxlength"
              :required="form.dono.required"
              :state="form.dono.state"
              disabled>
            </b-form-input>
          </div>
      </div>
      <div class="col-md-6 pt-2">
        <div class="col-md-12 pl-3" style="margin-top: 38px;">
          <b-form-checkbox v-model="form.publico.value" :required="form.publico.required" :state="form.publico.state" switch>
            <template slot="default">Tornar público</template>
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 text-right">
        <button type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="'Salvar'" @click.prevent="onSave"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span></button>
      </div>
    </template>
  </b-modal>
  </div>
</template>
<script>
// import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import { JWTService } from '@/shared/services/jwt'
import { loading, toast } from '@/shared/utils/UIHelper'

import GedMenuRepository from '@/shared/http/repositories/ged/gedmenu.js'

const menuForm = {
  nome: {
    value: '',
    maxlength: 100,
    required: true,
    state: null
  },
  publico: {
    value: false,
    required: false,
    state: null
  },
  dono: {
    value: '',
    maxlength: 100,
    required: true,
    state: null
  },
  secaoNome: {
    value: '',
    maxlength: 100,
    required: false,
    state: null
  },
  menuNome: {
    value: '',
    maxlength: 100,
    required: false,
    state: null
  }
}
const menuModel = {
  id: null,
  secaoId: null,
  menuId: null,
  nivel: 0,
  nome: null,
  publico: false,
  dono: null,
  tags: null
}

export default {
  name: 'ModalNewMenu',
  mixins: [ActionsForm],
  data () {
    return {
      data: menuModel,
      form: menuForm,
      section: null,
      menu: null,
      nivel: null
    }
  },
  mounted () {
  },
  methods: {
    showModal (obj) {
      this.onClear()
      this.$refs['modal-new-menu'].show()
      this.section = obj.secao
      this.menu = obj.menu
      this.nivel = obj.nivel
      // -->
      this.form.dono.value = JWTService.GetUserName()
      this.form.secaoNome.value = this.section.nome
      this.form.menuNome.value = this.menu ? this.menu.nome : ''
    },
    hideModal () {
      this.$refs['modal-new-menu'].hide()
    },
    onCreate () {
      this.data.publico = !!this.form.publico.value
      this.data.menuId = this.menu ? this.menu.id : null
      this.data.secaoId = this.section.id
      this.data.nivel = this.nivel
      this.data.dono = JWTService.GetUserId()

      loading.push()
      GedMenuRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.hideModal()
          toast.success(this.$lang.Common.Alerts.Success, 'MENU')
          this.$emit('Saved')
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/leftcontent/components/modalnewmenu.vue